import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { ProviderFormWrapperComponent } from '../components/provider-form-wrapper/provider-form-wrapper.component';
import {
  ProviderFormConfig,
  PROVIDER_FORM_CONFIG,
} from '../e-invoice-provider.config';

@Component({
  selector: 'app-provider-form',
  standalone: true,
  imports: [ProviderFormWrapperComponent],
  templateUrl: './provider-form.component.html',
  styleUrls: ['./provider-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProviderFormComponent implements CanComponentDeactivate {
  private readonly router = inject(Router);

  @ViewChild('formWrapper') private readonly formWrapper?: ProviderFormWrapperComponent;

  mode = computed<'add' | 'edit' | 'view'>(() => {
    const url = this.router.url;
    if (url.includes('/view/')) return 'view';
    if (url.includes('/edit/')) return 'edit';
    return 'add';
  });

  config = computed<ProviderFormConfig>(() => {
    const currentMode = this.mode();
    const titleKey =
      currentMode === 'view'
        ? 'e_invoice.provider.form.title_view'
        : currentMode === 'edit'
          ? 'e_invoice.provider.form.title_edit'
          : 'e_invoice.provider.form.title_add';

    return {
      title: titleKey,
      formFields: PROVIDER_FORM_CONFIG.formFields,
      headerActions: PROVIDER_FORM_CONFIG.headerActions,
      listRoute: '/configuration/e-invoice/provider',
    };
  });

  editMode = computed(() => this.mode() === 'edit');
  viewMode = computed(() => this.mode() === 'view');

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }
}
